import { createMemo } from "solid-js"
import type { Engine } from "../../lib/core/engine/Engine.type"
import { State } from "../../lib/core/state/State.type"
import createSharedCachedFactory from "../memo/createSharedCachedFactory"

export const useIsGameStateEndedMemo = createSharedCachedFactory((
  engine: Engine
) => {
  const memo = createMemo<State['ended']>(() => engine.state.ended)

  return memo
})
